import React from 'react'

export default ({ handleOpen }) => (
  <div
    className='Nav--Sandwich'
    onClick={handleOpen}
  >
    <div />
    <div />
    <div />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Sandwich.js